export default __webpack_public_path__ + "static/media/pptx.c018d769.svg";